export const DRAFT_VERSION = 1;

export type PersistedDraftEnvelope<T> = {
  draftVersion: number;
  state: T;
};

function isFile(value: unknown): value is File {
  return typeof File !== "undefined" && value instanceof File;
}

function sanitizeValue(value: unknown): unknown {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  if (isFile(value)) {
    return null;
  }
  if (Array.isArray(value)) {
    return value.map(sanitizeValue).filter((item) => item !== undefined);
  }
  if (typeof value === "object") {
    const result: Record<string, unknown> = {};
    for (const [key, nestedValue] of Object.entries(value)) {
      const sanitized = sanitizeValue(nestedValue);
      if (sanitized !== undefined) {
        result[key] = sanitized;
      }
    }
    return result;
  }
  return value;
}

export function serializeDraft<T>(state: T): string {
  const envelope: PersistedDraftEnvelope<T> = {
    draftVersion: DRAFT_VERSION,
    state: sanitizeValue(state) as T,
  };
  return JSON.stringify(envelope);
}
